var map = {
	"./atlas_logo_gray.png": "eb0f",
	"./atlas_logo_magenta.jpg": "fd98",
	"./bmat_logo.svg": "050f",
	"./bmat_logo_magenta.jpg": "7bea",
	"./bmat_logo_magenta_original.jpg": "fa15",
	"./filscap_logo.png": "4724",
	"./logo.png": "cf05",
	"./logo_2x.png": "c1fe",
	"./mct_logo.png": "24db",
	"./spa_logo.png": "c1f9",
	"./wami_logo.png": "9c21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";